import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { getFeedbackTypes } from 'src/actions/feedbackRequestAction';
import FeedbackListPage from './FeedbackListPage';
import { rowClick } from 'src/actions/completeOrderAction';
import { viewRateData } from 'src/actions/feedbackAction';

export const mapStateToProps = (state: AppState) => {  
  return {
    feedbackData: state.feedbackRequest.feedbackTypes,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
    //   dispatch(getFeedbackTypes);
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
    },
    dateFilter: (filterStartdate: Date, filterEnddate: Date) => {
      dispatch(getFeedbackTypes(filterStartdate, filterEnddate));
    },
    fbOrderView: (orderNo: string, dsorderid: string) => {
      dispatch(rowClick(orderNo, dsorderid));
    },
    fbOrderRated: (orderNo: string, dsorderid: string) => {
      dispatch(viewRateData(orderNo, dsorderid));
    },
    dateReset: (filterStartdate: Date, filterEnddate: Date) => {
      dispatch(getFeedbackTypes(filterStartdate, filterEnddate));
    },    
  };
};

const FeedbackListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedbackListPage);

export default FeedbackListContainer;



// WEBPACK FOOTER //
// ./src/components/feedbackRequest/FeedbackListContainer.tsx